var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.77 0.234481C11.0768 0.546992 11.0766 1.05352 10.7697 1.36585L4.4803 7.76585C4.33287 7.91587 4.13295 8.00009 3.92453 8C3.7161 7.99991 3.51625 7.9155 3.36896 7.76535L0.229803 4.56535C-0.0768564 4.25275 -0.0765636 3.74622 0.230458 3.43398C0.537479 3.12175 1.03497 3.12204 1.34163 3.43465L3.92536 6.06846L9.65887 0.234148C9.9658 -0.0781793 10.4633 -0.0780304 10.77 0.234481Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/Tick.38c36273495f685900eb29f496333d33.svg";
export { ForwardRef as ReactComponent };